import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';

const usePostUserLogout = () => {
  const endPoint = '/api-owner/user/logout';

  const postUserLogout = async () => {
    return axiosInstance
      .post(endPoint)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postUserLogout };
};

export default usePostUserLogout;
